import { SpacePickerHelpers } from "@swivl-mono/helpers";
import {
  ActionTakenType,
  FacilityAndSpaceFeatures,
  SpaceInterface,
  SpacePickerParams,
  SpacePickerPayload,
  UnitInterface,
  createActionTaken
} from "@swivl-mono/types";
// import { CarouselArrow } from './ArrowsAndDots';

import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import React, { useCallback, useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

import { Config } from "../../../../Config/Config";
import { SwivlChat } from "../../../../SwivlChat";
import { Dots } from "../../../../components/Dots/Dots";
import { LanguageContext, t } from "../../../../i18n/strings";
import { MessageHandlerInterface } from "../../../../messages/MessageHandler";
import { ListItemData } from "../../ListItem";
import { SpaceCard } from "./Components/SpaceCard";
import { SpacePickerFiltersModal } from "./Components/SpacePickerFiltersModal";
import "./SpacePicker.scss";

export type SpacePickerFilters = {
  dimensions: string[];
  selectedDimensions: string[];
  features: FacilityAndSpaceFeatures[];
  selectedFeatures: FacilityAndSpaceFeatures[];
  featureDisplayName: { [featureName: string]: string };
};

export function numberOfFiltersString(filters: SpacePickerFilters): string {
  let count = 0;
  count += filters.selectedFeatures.length;
  // if (filters.dimensions.length !== filters.selectedDimensions.length) {
  count += filters.selectedDimensions.length;
  // }
  return count ? `(${count})` : "";
}

const SelectedSpaceCell = (props: { space: UnitInterface; params: SpacePickerParams; delegate: SwivlChat }) => {
  const { space, params } = props;

  return (
    <div className="scc-SelectedSpaceCellWrapper">
      <div className="scc-SelectedSpaceCell">
        <div className="scc-spaceImage">
          <div className="scc-spaceImageBackground" style={{ background: Config.primaryButtonBackground }} />

          <img src={SpacePickerHelpers.imageAndTextURLForSpace(space, params).imageURL} />
        </div>
        <div className="scc-spaceText" style={{ background: Config.primaryButtonBackground }}>
          {space?.width} x {space?.length}
        </div>
      </div>
    </div>
  );
};

type LastOrNoResultsCardProps = {
  index: number;
  item: ListItemData;
  showFilters(): void;
  lastCard: boolean;
  delegate: SwivlChat;
};

const LastOrNoResultsCard = (props: LastOrNoResultsCardProps) => {
  const language = React.useContext(LanguageContext);
  const { index, showFilters, lastCard, delegate } = props;

  const differentStoreSelected = () => {
    if (!Config.canPressButtons) {
      return;
    }
    const messageId = props.item.message.uuid;

    const actionTaken = createActionTaken(ActionTakenType.Other, props.item.id);

    delegate.messageHandler.actionTaken(messageId, actionTaken);
  };

  return (
    <Slide index={index} key={"slide_" + index} innerClassName="scc-spaceSlide">
      <div className="scc-noSpaceResults">
        <div className="scc-noSpaceBox" style={{ color: Config.primaryButtonBackground }}>
          <div className="scc-noSpaceBoxBG swivl-primaryButton" />
          <div className="scc-noSpaceImage">
            {lastCard ? (
              <img src="https://swivl-cdn.s3.us-west-1.amazonaws.com/binoculars.png" />
            ) : (
              <img src="https://swivl-cdn.s3.us-west-1.amazonaws.com/no-results.png" />
            )}
          </div>

          <div className="scc-noSpaceBoxText">
            <div className="scc-noSpaceResultsHeading">
              {lastCard ? t("inventoryPickerCantFind", language) : t("inventoryPickerNoMatches", language)}
            </div>
            <div className="scc-noSpaceResultsSubHeading">{t("inventoryPickerRefineSearch", language)}</div>
          </div>
        </div>
        <div onClick={differentStoreSelected} className="scc-noSpaceSearchAgain swivl-primaryButton">
          {t("inventoryPickerSearchAnotherStore", language)}
        </div>
        <div onClick={showFilters} className="scc-noSpaceEditFilters swivl-primaryButton">
          {t("inventoryPickerEditFilters", language)}
        </div>
      </div>
    </Slide>
  );
};

interface Props {
  item: ListItemData;
  messageHandler: MessageHandlerInterface;
  width: number;
  height: number;
  isActive: boolean;
  delegate: SwivlChat;
}
export interface State {
  shouldFocusOnControl?: string;
  filters: SpacePickerFilters;
}

function locationHasFeature(space: SpaceInterface, feature: FacilityAndSpaceFeatures) {
  if (space.features?.includes(feature)) {
    return true;
  }
  return false;
  // if (feature === FacilityAndSpaceFeatures.Inside           && !space.isInside) { return false; }
  // if (feature === FacilityAndSpaceFeatures.Power            && !space.hasPower) { return false; }
  // if (feature === FacilityAndSpaceFeatures.Alarm            && !space.hasAlarm) { return false; }
  // if (feature === FacilityAndSpaceFeatures.ClimateControl  && !space.hasClimateControl) { return false; }
  // if (feature === FacilityAndSpaceFeatures.DriveUp         && !space.isDriveUp) { return false; }
  // if (feature === FacilityAndSpaceFeatures.ElevatorAccess   && !space.hasElevatorAccess) { return false; }
  // if (feature === FacilityAndSpaceFeatures.UpperLevel      && !space.isUpperLevel) { return false;
  // } else
  // if (feature === FacilityAndSpaceFeatures.FirstFloor      && space.floor !== 1 && !space.isUpperLevel) { return false; }

  return true;
}

export class SpacePicker extends React.Component<Props, State> {
  static contextType = LanguageContext;
  declare context: React.ContextType<typeof LanguageContext>;
  constructor(props: Props) {
    super(props);
    const payload = props.item.message.payload as SpacePickerPayload;

    let filters: SpacePickerFilters = {
      selectedDimensions: [],
      dimensions: [],
      selectedFeatures: [],
      features: [],
      featureDisplayName: {}
    };

    if (!(props.item.message.actionTaken || !props.isActive)) {
      let dimensionsObj = {};
      let featuresObj = {};
      payload.spaces.forEach((space: any) => {
        dimensionsObj[space.dimensions] = true;
        if (
          payload.params.preSelectedDimensions &&
          payload.params.preSelectedDimensions.includes(space.dimensions) &&
          !filters.selectedDimensions.includes(space.dimensions)
        ) {
          filters.selectedDimensions.push(space.dimensions);
        }

        if (space.features) {
          space.features.forEach((f) => {
            if (!filters.features.includes(f)) {
              filters.features.push(f);
            }
          });
        }
        // for (let name in FacilityAndSpaceFeatures) {
        //    if (!featuresObj[name] && locationHasFeature(space, FacilityAndSpaceFeatures[name]) ) {
        //     featuresObj[name] = true;
        //    }
        // };
      });
      filters.dimensions = Object.keys(dimensionsObj);
      // filters.features = Object.keys(featuresObj)
      filters.featureDisplayName = payload?.params?.featureDisplayName || {};

      // filters.features.forEach(f => {
      //   if (!filters.featureDisplayName[f]) {
      //     filters.featureDisplayName[f] = SpaceFeatureDisplayName(FacilityAndSpaceFeatures[f])
      //   }
      // })
    }

    if (payload.params.preSelectedFeatures) {
      // Preselect any feature filters sent in.
      for (let i = 0; i < payload.params.preSelectedFeatures.length; i++) {
        for (let f = 0; f < filters.features.length; f++) {
          if (filters.features[f].toLowerCase().trim() === payload.params.preSelectedFeatures[i].toLowerCase().trim()) {
            filters.selectedFeatures.push(filters.features[f]);
          }
        }
      }
    }

    this.state = { shouldFocusOnControl: undefined, filters: filters };
    this.showFilters = this.showFilters.bind(this);
    this.updateFilters = this.updateFilters.bind(this);
  }

  // createDot(index) { return <Dot slide={index} key={"dot" +index}  ><svg height="10" width="10"><circle className="swivl-fillPrimary" cx="5" cy="5" r="4" /> </svg></Dot> }

  arrow(isRight: boolean) {
    return (
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" transform={isRight ? "scale(-1,1) translate(-24,0)" : ""} strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-10.000000, -467.000000)">
            <g transform="translate(10.000000, 467.000000)">
              <circle className="swivl-fillPrimary" cx="12" cy="12" r="12"></circle>
              <polyline
                stroke="#FFFFFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(14.000000, 12.000000) rotate(-315.000000) translate(-14.000000, -12.000000) "
                points="10 8 10 16 18 16"
              ></polyline>
            </g>
          </g>
        </g>
      </svg>
    );
  }

  showFilters() {
    this.props.delegate.showModal(
      <SpacePickerFiltersModal filters={this.state.filters} updateFilters={this.updateFilters} delegate={this.props.delegate} />
    );
  }
  updateFilters(filters: SpacePickerFilters) {
    this.setState({ filters: filters });
  }

  filterSpaces(filters: SpacePickerFilters, spaces: UnitInterface[]) {
    return spaces.filter((s: UnitInterface) => {
      if (filters.selectedDimensions.length != 0 && s.dimensions && !filters.selectedDimensions.includes(s.dimensions)) {
        return false;
      }
      for (let index = 0; index < filters.selectedFeatures.length; index++) {
        const feature = filters.selectedFeatures[index];
        if (!s.features?.includes(feature)) {
          return false;
        }
      }
      return true;
    });

    // return spaces.filter((s: UnitInterface) => {
    //   if (filters.selectedDimensions.length != 0 && s.dimensions && !filters.selectedDimensions.includes(s.dimensions)) {
    //     return false;
    //   }
    //   for (let index = 0; index < filters.selectedFeatures.length; index++) {
    //     const feature = filters.selectedFeatures[index];
    //     if (!s.features?.includes(feature)) {
    //       return false;
    //     }
    //   }

    //   // if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.IsParking) && !s.isParking) {

    //   //   return false;
    //   // }

    //   // if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.Indoor) && !s.isInside) { return false; }
    //   // if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.Power) && !s.hasPower) { return false; }
    //   // if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.Alarm) && !s.hasAlarm) {

    //   //   return false;
    //   // }
    //   // if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.ClimateControl) && !s.hasClimateControl) { return false; }

    //   // if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.DriveUp) && !s.isDriveUp) { return false; }
    //   // if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.UpperLevel) &&
    //   //     (!s.isUpperLevel || s.floor === 1)) {
    //   //       return false;
    //   // } else if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.FirstFloor) && (s.floor !== 1 || s.isUpperLevel)) { return false; }
    //   // if (filters.selectedFeatures.includes(FacilityAndSpaceFeatures.ElevatorAccess) && !s.hasElevatorAccess) { return false; }

    //   return true;
    //   // "Indoor",
    //   // "Power",
    //   // "Alarm",
    //   // "Climate Control",
    //   // "1st Floor",
    // });
  }

  render() {
    const { item, messageHandler, isActive, delegate } = this.props;
    const payload = item.message.payload as SpacePickerPayload;

    const { filters } = this.state;
    if (item.message.actionTaken) {
      if (item.message.actionTaken.type === ActionTakenType.Other) {
        return <div className="scc-ButtonsItem swivl-primaryButton">{t("inventoryPickerSearchAnotherStore", this.context)}</div>;
      }

      const data = item.message.actionTaken?.data as UnitInterface;
      return <SelectedSpaceCell space={data} params={payload.params} delegate={delegate} />;
    }
    if (!isActive) {
      return null;
    }

    let slides: any = [];
    // let dots = []

    const spaces = this.filterSpaces(filters, payload.spaces);

    let key = "Provider";

    spaces.forEach((space, index) => {
      key += space.id;

      slides.push(
        <SpaceCard
          space={space}
          index={index}
          key={space.id}
          messageHandler={messageHandler}
          item={item}
          delegate={delegate}
          params={payload.params}
          filterDisplayNames={filters.featureDisplayName}
          currenySymbol={payload.params.currencySymbol}
        />
      );
      // dots.push(this.createDot(index))
    });

    if (slides.length === 0) {
      key += "noresults";

      slides.push(<LastOrNoResultsCard key="noresults" index={0} showFilters={this.showFilters} lastCard={false} delegate={delegate} item={item} />);
      // dots.push(this.createDot(0))
    } else {
      slides.push(
        <LastOrNoResultsCard key="lastCard" index={slides.length} showFilters={this.showFilters} lastCard={true} delegate={delegate} item={item} />
      );
      // dots.push(this.createDot(dots.length))
    }

    // if (slideGroup.length) {
    //     dots.push(this.createDot(slides.length))
    //     slides.push( <SpaceCard index={slides.length} /> );
    // }

    let className = "scc-SpacePicker";
    let naturalSlideHeight = Math.min(393, this.props.height);

    const locationName = payload.location?.name || t("inventoryPickerSpacesAvailable", this.context);

    return (
      <div className={className}>
        <CarouselProvider
          naturalSlideWidth={this.props.width}
          naturalSlideHeight={naturalSlideHeight}
          totalSlides={slides.length}
          disableKeyboard={true}
          className="scc-carouselProvider"
          key={key}
        >
          <div className="scc-spacePickerHeader swivl-linkContainer">
            <div className="scc-spaceLocationName">{locationName}</div>
            <a className="scc-spaceLocationFilters" onClick={this.showFilters}>
              {t("inventoryPickerFilter", this.context)} {numberOfFiltersString(filters)}
            </a>
          </div>

          <Slider className="scc-slider">{slides}</Slider>
          <div className="scc-controlsRow">
            <ButtonBack className="scc-nextAndBackButton">{this.arrow(false)}</ButtonBack>
            <div className="dotGroup">
              {/* {dots} */}

              <Dots numberOfDots={slides.length} activeDot={0} dotClicked={() => {}} />
            </div>
            <ButtonNext className="scc-nextAndBackButton">{this.arrow(true)}</ButtonNext>
          </div>
        </CarouselProvider>
      </div>
    );
  }
}
